module.exports = __webpack_public_path__ + "img/Pot3.0e69ef04.svg";